module.exports = __webpack_public_path__ + "static/media/logo.d77f4cf1.svg";